<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-12">
                        <app-sub-header *ngIf="bulltineID == undefined" title="Add Bulletin"></app-sub-header>
                        <app-sub-header *ngIf="bulltineID != undefined" title="Update Bulletin"></app-sub-header>

                    </div>

                </div>

                <div class="row">
                    <div class="col-md-12">
                        <form [formGroup]="form" (ngSubmit)="formRequest()" autocomplete="off">
                            <div style="min-height: 500px;">

                                <div class="form-group">
                                    <input type="text" formControlName="name" placeholder="Bulletin Title"
                                        class="form-control" [ngClass]="{ 'is-invalid': submitted && f.name.errors }">

                                    <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                        <div style="text-align: right;" *ngIf="f.name.errors.required">
                                            {{errorMessage}}</div>
                                    </div>
                                </div>

                                <div class="form-group margin-b">
                                    <input type="text" placeholder="Bulletin Link" class="form-control"
                                        formControlName="link">
                                        (optional)
                                </div>

                                <div class="form-group register-input">
                                    <label class="btn-bs-file color btn btn-lg main-backgroundcolor">
                                        Upload Document
                                        <input type="file" (change)="uploadBanner($event)" accept="image/*,.pdf" />
                                    </label>
                                </div>


                                <div style="text-align: right; color: red; " *ngIf="errorShow">
                                    <p style="font-size: 16px;">{{error}}
                                    <p>
                                </div>

                                <div class="form-group">
                                    <a [href]="file" target="_blank">
                                        <p>{{fileName}}</p>
                                    </a>
                                </div>



                                <div class="form-group">
                                    <select class="form-control" formControlName="expirationDay"
                                        [ngClass]="{ 'is-invalid': submitted && f.expirationDay.errors }">

                                        <option value="">Select Expiration days</option>
                                        <option *ngFor="let props of expirationdays" [value]="props">{{props}}</option>

                                    </select>

                                    <div *ngIf="submitted && f.expirationDay.errors" class="invalid-feedback">
                                        <div style="text-align: right;" *ngIf="f.expirationDay.errors.required">
                                            {{errorMessage}}</div>
                                    </div>
                                </div>
                            </div>




                            <button *ngIf="bulltineID == undefined" type="submit"
                                class="btn color btn-lg btn-block main-backgroundcolor">Add</button>
                            <button *ngIf="bulltineID != undefined" type="submit"
                                class="btn color btn-lg btn-block main-backgroundcolor">Update</button>                        </form>

                    </div>
                </div>







            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>
